export default "__VITE_ASSET__CfQtIuHl__"